import { createSlice } from "@reduxjs/toolkit";

// define state here
const initialState = {
  data: [],
  totalRecords: 0,
  isFetching: false,
  error: null,
};

export const companySlice = createSlice({
  name: "companyData",
  initialState,
  reducers: {
    fetchDataBegin: (state) => {
      state.isFetching = true;
      state.error = null;
    },
    fetchDataError: (state, action) => {
      const { message = null } = action.payload;
      state.isFetching = false;
      state.error = message;
    },

    getCompanySuccess: (state, action) => {
      const { newData } = action.payload;
      state.isFetching = false;
      state.data = newData;
      state.totalRecords = newData.length;
    },
  },
});

export const { fetchDataBegin, fetchDataError, getCompanySuccess } =
  companySlice.actions;

export const companyDataSelector = (state) => state.companyData.data;

export default companySlice.reducer;
